import React from 'react';
import { motion } from 'framer-motion';
import { footerVariants } from './animations';

/**
 * LoginFooter Component
 * 
 * Copyright footer for the login page.
 * Automatically displays current year.
 * 
 * @example
 * <LoginFooter />
 */
const LoginFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      variants={footerVariants}
      initial="initial"
      animate="animate"
      className="text-center mt-8 text-sm text-haat-gray-light"
    >
      <p>© {currentYear} HAAT Delivery. All rights reserved.</p>
    </motion.footer>
  );
};

export default LoginFooter;

